/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1ExamImportExamItemBatchMutationRequest,
  PostApiV1ExamImportExamItemBatchMutationResponse,
  PostApiV1ExamImportExamItemBatch400,
  PostApiV1ExamImportExamItemBatch401,
  PostApiV1ExamImportExamItemBatch404,
  PostApiV1ExamImportExamItemBatch500,
} from "../../types/examEvaluationController/PostApiV1ExamImportExamItemBatch.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1ExamImportExamItemBatch } from "../../clients/examEvaluationController/postApiV1ExamImportExamItemBatch.ts";

export const postApiV1ExamImportExamItemBatchMutationKey = () =>
  [{ url: "/api/v1/exam/import-exam-item-batch" }] as const;

export type PostApiV1ExamImportExamItemBatchMutationKey = ReturnType<
  typeof postApiV1ExamImportExamItemBatchMutationKey
>;

export function postApiV1ExamImportExamItemBatchMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1ExamImportExamItemBatchMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = postApiV1ExamImportExamItemBatchMutationKey();
  return mutationOptions<
    PostApiV1ExamImportExamItemBatchMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamImportExamItemBatch400
      | PostApiV1ExamImportExamItemBatch401
      | PostApiV1ExamImportExamItemBatch404
      | PostApiV1ExamImportExamItemBatch500
    >,
    { data?: PostApiV1ExamImportExamItemBatchMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1ExamImportExamItemBatch(data, config);
    },
  });
}

/**
 * @description Importa questões da biblioteca para uma versões de provas (ExamLang), criando cópias vinculadas ao ExamLang informado. Questões já importadas e não canceladas são ignoradas. Quando a questão possui lista de respostas (Escolha Simples ou Múltipla), a lista e seus valores são duplicados para a cópia. Requer que o ExamLang e a empresa da prova sejam acessíveis pelo usuário logado. **(Requer Authorization para autenticação)**
 * @summary Importar questões em lote para uma versão de prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam/import-exam-item-batch}
 */
export function usePostApiV1ExamImportExamItemBatch<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1ExamImportExamItemBatchMutationResponse,
      ResponseErrorConfig<
        | PostApiV1ExamImportExamItemBatch400
        | PostApiV1ExamImportExamItemBatch401
        | PostApiV1ExamImportExamItemBatch404
        | PostApiV1ExamImportExamItemBatch500
      >,
      { data?: PostApiV1ExamImportExamItemBatchMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1ExamImportExamItemBatchMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1ExamImportExamItemBatchMutationKey();

  const baseOptions = postApiV1ExamImportExamItemBatchMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1ExamImportExamItemBatchMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamImportExamItemBatch400
      | PostApiV1ExamImportExamItemBatch401
      | PostApiV1ExamImportExamItemBatch404
      | PostApiV1ExamImportExamItemBatch500
    >,
    { data?: PostApiV1ExamImportExamItemBatchMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1ExamImportExamItemBatchMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamImportExamItemBatch400
      | PostApiV1ExamImportExamItemBatch401
      | PostApiV1ExamImportExamItemBatch404
      | PostApiV1ExamImportExamItemBatch500
    >,
    { data?: PostApiV1ExamImportExamItemBatchMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1ExamImportExamItemBatchMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamImportExamItemBatch400
      | PostApiV1ExamImportExamItemBatch401
      | PostApiV1ExamImportExamItemBatch404
      | PostApiV1ExamImportExamItemBatch500
    >,
    { data?: PostApiV1ExamImportExamItemBatchMutationRequest },
    TContext
  >;
}
